import { ReferralDirectoryRecordSchema } from "@emr/contracts";
import { z } from "zod";

export const SpecialtyCodeSchema = z.string().min(1).max(80);

export const ReferralDirectorySearchResultSchema = z.object({
  items: z.array(ReferralDirectoryRecordSchema),
});

export type ReferralDirectoryEntry = z.infer<typeof ReferralDirectoryRecordSchema>;
